const { Fancybox } = await import('@fancyapps/ui');

if (!customElements.get('product-page-customiser')) {
  class ProductPageCustomiser extends HTMLElement {
    constructor() {
      super();

      if (location.search.indexOf('configurationCode') > -1) {
        let array = location.search.split('=');
        let configCodeStripped = array[array.length - 1];
        document.querySelector('#configCode').value = configCodeStripped;
      }

      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.openPopup.bind(this));
      this.saveData = '';
      this.handleInit = true;
      this.configCodeInput = document.getElementById('configCode');
      this.configData = JSON.parse(this.dataset.config);

      let configCode = '';
      let configCodeStripped = '';
      if (location.search.indexOf('configurationCode') > -1) {
        let array = location.search.split('=');
        configCode = '&configurationCode=' + array[array.length - 1];
        configCodeStripped = array[array.length - 1];
      }
      this.url = this.configData.url + '?wait_for_initialization=true' + configCode;
      this.configCodeInput.value = configCodeStripped;
      this.iframeOpen = false;

      //this.initIframe(this.configData);
      this.sortWindowMessage();
    }

    sortWindowMessage() {
      window.addEventListener('message', (e) => {
        // guard against different messages
        if (typeof e.data !== 'string') {
          return false;
        }

        if (e.data.indexOf('{') == -1) {
          return false;
        }

        const data = JSON.parse(e.data);

        if (data.length < 3) {
          return false;
        }

        if (data.type === 'ready_initialization') {
          this.handleInit = true;
          this.saveData = data;
          //handleInitialization(data);
        } else if (data.type === 'configuration_saved') {
          this.handleInit = false;
          this.saveData = data;
          if (this.iframeOpen) {
            this.handleConfigurationSaved(data);
          }
        } else if (data.type === 'at_closing') {
          Fancybox.close(true);
        }
      });
    }

    handleInitialization(configData) {
      const overrides = [
        {
          value: parseInt(configData.base_price),
          path: 'custom.alpinestars.pricing.base_price',
        },
        {
          value: window.Shopify.currency.active,
          path: 'custom.alpinestars.pricing.currency',
        },
        {
          value: configData.currency_prefix,
          path: 'custom.alpinestars.pricing.currency_prefix',
        },
        {
          value: configData.currency_suffix,
          path: 'custom.alpinestars.pricing.currency_suffix',
        },
        {
          value: window.Shopify.locale, // "en", "fr", "de", "es", "it"
          path: 'custom.alpinestars.i8n',
        },
        {
          value: parseInt(configData.non_vector_logo),
          path: 'custom.alpinestars.pricing.non_vector_logo',
        },
        {
          path: 'custom.alpinestars.pricing.size',
          value: [
            {
              id: 'made_to_measure',
              value: parseInt(configData.made_to_measure_price),
            },
            {
              id: 'adjustment',
              value: parseInt(configData.standard_adjustment),
            },
          ],
        },
        {
          value: 'E-mail your configuration', // Replace with your desired button text
          path: 'custom.alpinestars.pricing.buyButtonText',
        },
        {
          path: 'custom.alpinestars.pricing.items',
          value: [
            {
              config_name: 'leg_cuffs',
              config_option: 'cuffs_standard', // Assuming 'cuffs_standard' for initial value, adjust based on actual data
              value: 0, // This needs a value, adjust based on actual data if available
            },
            {
              config_name: 'leg_cuffs',
              config_option: 'cuffs_boot',
              value: parseInt(configData.cuffs_boot),
            },
            {
              config_name: 'phone_pocket',
              config_option: 'left_phone_pocket', // Assuming 'left_phone_pocket' for initial value, adjust based on actual data
              value: parseInt(configData.with_phone_pocket), // This needs a value, adjust based on actual data if available
            },
            {
              config_name: 'phone_pocket',
              config_option: 'right_phone_pocket', // Assuming 'right_phone_pocket' for initial value, adjust based on actual data
              value: parseInt(configData.with_phone_pocket), // This needs a value, adjust based on actual data if available
            },
            // {
            //   config_name: 'belt',
            //   config_option: 'belt',  // Assuming 'belt' for initial value, adjust based on actual data
            //   value: 5,  // This needs a value, adjust based on actual data if available
            // },
            // {
            //   config_name: 'belt',
            //   config_option: 'no_belt',  // Assuming 'no_belt' for initial value, adjust based on actual data
            //   value: 0.001,  // This needs a value, adjust based on actual data if available
            // },
            // {
            //   config_name: 'pocket',
            //   config_option: 'no_pockets',  // Assuming 'no_pockets' for initial value, adjust based on actual data
            //   value: 0.1,  // This needs a value, adjust based on actual data if available
            // },
            // {
            //   config_name: 'pocket',
            //   config_option: 'pockets',  // Assuming 'pockets' for initial value, adjust based on actual data
            //   value: 2,  // This needs a value, adjust based on actual data if available
            // },
          ],
        },
      ];

      const defaultCfg = undefined;
      const initializationMessage = JSON.stringify({
        type: 'initialize',
        payload: {
          overrides,
          defaultCfg,
        },
      });

      iframe.contentWindow.postMessage(initializationMessage, '*');
    }

    handleConfigurationSaved(data) {
      // inits
      let configObject = {};
      let configData = this.configData;
      let suitConfig = data.payload.configuration;
      let thumbnails = data.payload.thumbnails;
      let thumbnail = data.payload.thumbnails[0].downloadUrl;
      let configId = data.payload.code;

      // build suit config and collect logo count and non_vector_logo
      let logoCount = 0;
      let vectorLogoCount = 0;
      let non_vector_logo = false;
      suitConfig.forEach((config) => {
        if (config.key.indexOf('logo_') > -1) {
          if (config.value.logos.length > 0) {
            let nonVectorLogos = 0;
            let vectorLogos = 0;
            config.value.logos.forEach((logo) => {
              let logoType = logo.type;
              if (
                logoType.indexOf('jpg') > -1 ||
                logoType.indexOf('png') > -1 ||
                logoType.indexOf('jpeg') > -1 ||
                logoType.indexOf('gif') > -1
              ) {
                non_vector_logo = true;
                nonVectorLogos = nonVectorLogos + 1;
              } else {
                vectorLogos = vectorLogos + 1;
              }
            });
            logoCount = logoCount + vectorLogos;
            vectorLogoCount = vectorLogoCount + nonVectorLogos;
          }
        }
        configObject[config.key] = config.value;
      });

      // price inits
      let logoCountPrice = 0;
      let pocketPrice = 0;
      let phone_pocketPrice = 0;
      let beltPrice = 0;
      let leg_cuffsPrice = 0;
      let driver_flagPrice = 0;
      let driver_namePrice = 0;
      let blood_groupPrice = 0;
      let non_vector_logoPrice = 0;

      let comment = {
        '_suit-config-id': configId,
        '_suit-thumbnail': thumbnail,
        '_suit-config': true,
        '_suit-logos': logoCountPrice,
        '_suit-pocket': pocketPrice,
        '_suit-phone_pocket': phone_pocketPrice,
        '_suit-belt': beltPrice,
        '_suit-leg_cuffs': leg_cuffsPrice,
        '_suit-driver_flag': driver_flagPrice,
        '_suit-driver_name': driver_namePrice,
        '_suit-blood_group': blood_groupPrice,
        '_suit-non_vector_logo': non_vector_logoPrice,
        '_suit-non_vector_logo_count': vectorLogoCount,
      };

      document.querySelector('[data-customiser-load]').classList.add('hidden');
      document.querySelector('[data-customiser-success]').classList.remove('hidden');
      document.querySelector('[data-customiser-success] img').src = thumbnail;
      document.querySelector('[data-customiser-success-code]').innerHTML = configId;
      setTimeout(function () {
        document.querySelector('[data-page-customiser-form]').classList.remove('hidden');
      }, 500);
      Fancybox.close(true);

      CF.ready(function () {
        // Find the first CF form on the page.
        let myForm = document.querySelector('form[data-cf-form]');
        myForm.cfForm.setFieldValue('form_body', JSON.stringify(comment));
        myForm.cfForm.setFieldValue('suit_thumbnail', thumbnail);
        myForm.cfForm.setFieldValue('suit_config_id', configId);
        if (location.href.indexOf('?configCode') > -1) {
          myForm.cfForm.setFieldValue('customiser_url', location.href);
        } else {
          if (configId.length > 0) {
            myForm.cfForm.setFieldValue(
              'customiser_url',
              location.href + '?configurationCode=' + configId
            );
          } else {
            myForm.cfForm.setFieldValue('customiser_url', location.href);
          }
        }
        myForm.cfForm.setFieldValue('suit_thumbnail_1', thumbnails[0].downloadUrl);
        myForm.cfForm.setFieldValue('suit_thumbnail_2', thumbnails[1].downloadUrl);
        myForm.cfForm.setFieldValue('suit_thumbnail_3', thumbnails[2].downloadUrl);
        myForm.cfForm.setFieldValue('suit_thumbnail_4', thumbnails[3].downloadUrl);
        if (window.alpinestars_refferal) {
          myForm.cfForm.setFieldValue('refferal', window.alpinestars_refferal);
        }
        if (window.alpinestars_refferal_email) {
          myForm.cfForm.setFieldValue('refferal_email', window.alpinestars_refferal_email);
        }
        // myForm.cfForm.beforeSave(() => {
        //   document.querySelector('[data-customiser-success]').classList.add('hidden');
        // });
      });
    }

    openPopup(event) {
      let that = this;

      // apply configCode
      let configCode = this.configCodeInput.value;

      if (configCode.length > 0) {
        if (this.url.indexOf('configurationCode=') > -1) {
          let subUrl = this.url.split('configurationCode=');
          this.url = subUrl[0] + '&configurationCode=' + configCode;
        } else {
          this.url = this.url + '&configurationCode=' + configCode;
        }
      }

      new Fancybox(
        [
          {
            src: this.url,
            type: 'iframe',
            fullscreen: {
              autoStart: true,
            },
          },
        ],
        {
          on: {
            done: (fancybox, eventName) => {
              window.iframe = document.querySelector('.fancybox__iframe');
              if (that.handleInit) {
                that.handleInitialization(that.configData);
              } else {
                that.handleConfigurationSaved(that.saveData);
              }
              this.iframeOpen = true;
            },
          },
        }
      );
    }
  }

  window.ProductPageCustomiser = ProductPageCustomiser;

  customElements.define('product-page-customiser', ProductPageCustomiser);
}
